import { render, staticRenderFns } from "./PleaseLogIn.vue?vue&type=template&id=6f4536bb&"
import script from "./PleaseLogIn.vue?vue&type=script&lang=js&"
export * from "./PleaseLogIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4536bb')) {
      api.createRecord('6f4536bb', component.options)
    } else {
      api.reload('6f4536bb', component.options)
    }
    module.hot.accept("./PleaseLogIn.vue?vue&type=template&id=6f4536bb&", function () {
      api.rerender('6f4536bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/PleaseLogIn.vue"
export default component.exports